import Carousel from 'react-bootstrap/Carousel';
import { Figure } from '../../atoms/figure/Figure';
import { Icon, IconColor } from '../../atoms/icon/Icon';
import * as styles from './ImageCarousel.module.scss';

interface IImageCarouselProps {
    items: ICarouselItem[];
}

interface ICarouselItem {
    altText: string;
    caption?: string;
    captionNumber?: string;
    src: string;
}

export function ImageCarousel(props: IImageCarouselProps) {
    const prevIcon = (
        <div className={styles.carouselIcon}>
            <Icon
                className={styles.iconCaretLeft}
                color={IconColor.primary}
                icon="caret-left"
            />
        </div>
    );
    const nextIcon = (
        <div className={styles.carouselIcon}>
            <Icon
                className={styles.iconCaretRight}
                color={IconColor.primary}
                icon="caret-right"
            />
        </div>
    );

    return (
        <Carousel
            controls={props.items && props.items.length > 1}
            indicators={props.items && props.items.length > 1}
            interval={null}
            nextIcon={nextIcon}
            prevIcon={prevIcon}
        >
            {props.items.map((item) => (
                <Carousel.Item key={item.src}>
                    <Figure
                        alt={item.altText}
                        className="mb-0"
                        imageUrl={item.src}
                        imgClassName="w-100"
                    />
                    {item.caption && (
                        <Carousel.Caption className={styles.carouselCaption}>
                            <div className={styles.caption}>
                                {item.captionNumber && <p className={styles.captionNumber}>{item.captionNumber}</p>}
                                <p className={styles.captionText}>{item.caption}</p>
                            </div>
                        </Carousel.Caption>
                    )}
                </Carousel.Item>
            ))}
        </Carousel>
    );
}
